<template>
    <main class="dashboard">
        <div class="main-section" style=" background: rgb(248, 249, 253);">
            <div class="container has-background-white p-3">
                <div class="tipo_negocio mb-4">
                    <h2 class="title has-text-centered">
                        Entrada de datos
                    </h2>
                </div>
                <table class="table is-striped is-hoverable is-fullwidth has-text-centered">
                    <thead>
                        <tr>
                            <th>Entrada</th>
                            <th>Última Actualización</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="file in fileData" v-bind:key="file.fileType">
                            <td class="content is-vcentered">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #f5f5f9, #fafaff)`"
                                    @click="openFileModal(file.file_id, file.desc)">{{ file.desc }}</SimpleButton>
                            </td>
                            <td>
                                {{ moment(file.latest_date).format("DD-MM-YYYY") }}
                                <p v-if="!isLessThanMonth(file.latest_date)">
                                    <strong>(Atraso)</strong>
                                </p>
                                <p class="" v-if="!file.uploaded && isLessThanMonth(file.latest_date)">
                                    <strong>(Problema en el archivo)</strong>
                                </p>
                            </td>
                            <td class="content is-vcentered">
                                <!-- {{ file.uploaded }} -->
                                <p>
                                    <!-- a v-if="!file.uploaded || !isLessThanMonth(file.latest_date)"
                                        class="mr-3"><u>Solicitar</u></a -->
                                    <SimpleButton :buttonStyle="`linear-gradient(225deg, #faf5f5, #fff0f0)`"
                                        @click="openSolicitarArchivo(file.file_id)">Solicitar</SimpleButton>
                                    <SimpleButton :buttonStyle="`linear-gradient(225deg, #f5faf5, #f0fff0)`"
                                        @click="openUploadFileUsers(file.file_id)">Subir</SimpleButton>
                                    <a v-if="false"><u>Soporte </u></a>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </main>
</template>

<script>
import { getFilesUsersByCompany } from "@/api/uploadFiles";
import CompanyUploads from "@/components/modals/CompanyUploads";
import SimpleButton from "@/components/modals/SimpleButton";
import UploadFileAsUserModal from "@/components/modals/UploadFileAsUserModal";
import moment from "moment";

export default {
    name: "CompanyInfoDataEntry",
    components: {
        SimpleButton
    },
    created() {
    },
    mounted() {
        const company_id = this.$route.query.companyId;
        this.companyId = company_id
        getFilesUsersByCompany(company_id).then(({ data }) => {
            this.allFilesByUser = data;
        });
    },
    data() {
        return {
            allFilesByUser: [],
            companyId: '',
            modalDefault: {
                parent: this,
                hasModalCard: true,
                width: "99%",
                height: 1000,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
                "full-screen": true,
            },
            modalDefaultUpdateSheet: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
        };
    },
    computed: {
    },
    props: {
        basicData: {
            type: Object,
            required: true,
        },
        fileData: {
            type: Array,
            required: true,
        }
    },
    methods: {
        moment(date) {
            return moment(date);
        },
        isLessThanMonth(date) {
            let today = moment();
            let monthBefore = today.subtract(1, "months");
            let compareDate = moment(date);
            return monthBefore <= compareDate;
        },
        openFileModal(id, file_desc) {
            this.basicData["file_id"] = id;
            this.basicData["file_desc"] = file_desc;
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: CompanyUploads,
                props: {
                    basicData: this.basicData,
                },
            });
        },
        openUploadFileUsers(fileId) {
            let allUsersByFileId = this.allFilesByUser.filter((fileUser) => {
                let fileFound = fileUser.files.filter((file) => file.id == fileId);
                return fileFound.length > 0;
            });
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ["escape", "button", "outside"],
                onCancel: () => this.onModalClose(),
                props: {
                    fileId,
                    idCompany: this.companyId,
                    hideHistoricBtn: false,
                    selectedFilesByUser: allUsersByFileId,
                    sendMail: false,
                },
                events: {
                    close: () => {
                        this.onModalClose();
                    },
                },
            });
        },
        openSolicitarArchivo(fileId) {
            let allUsersByFileId = this.allFilesByUser.filter((fileUser) => {
                let fileFound = fileUser.files.filter((file) => file.id == fileId);
                return fileFound.length > 0;
            });
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ["escape", "button", "outside"],
                onCancel: () => this.onModalClose(),
                props: {
                    fileId,
                    idCompany: this.companyId,
                    hideHistoricBtn: false,
                    selectedFilesByUser: allUsersByFileId,
                    sendMail: true,
                },
                events: {
                    close: () => {
                        this.onModalClose();
                    },
                },
            });
        },
        onModalClose() {
        },
    },
};
</script>